// ProgressBar.jsx

import React from 'react';
import './ProgressBar.css';
import './styles.css'; 
import './index.css'; 
import './App.css'; 

const ProgressBar = ({ show }) => {
  return show ? (
    <div className="progress-bar-container">
      <div className="progress-bar-item"></div>
      <div className="progress-bar-item"></div>
      <div className="progress-bar-item"></div>
      <div className="progress-bar-item"></div>
    </div>
  ) : null;
};

export default ProgressBar;